import { render, staticRenderFns } from "./DinarInventory.vue?vue&type=template&id=7cb47832"
import script from "./DinarInventory.vue?vue&type=script&lang=js"
export * from "./DinarInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports